const NotifyMe = ({ openNotifyMeModal, product }) => {
  return (
    <div className="bg-slate-500 p-7 rounded-md w-[472px]" style={{backgroundColor: "#FCFAF1"}}>
      <p className="text-md font-bold">Notify me when this product is back in stock</p>
      <p className="text-sm font-light text-[#666666]">Once this product is restocked, you will receive an email.</p>

      <button onClick={(ev) => {ev.preventDefault(); openNotifyMeModal(product)}} style={{color: "blue"}} className="mt-5">Notify me</button>
    </div>
  )
}

export default NotifyMe;